import { render, staticRenderFns } from "./upload_video.vue?vue&type=template&id=3524c0a6&"
import script from "./upload_video.vue?vue&type=script&lang=js&"
export * from "./upload_video.vue?vue&type=script&lang=js&"
import style0 from "./upload_video.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports